// extracted by mini-css-extract-plugin
module.exports = {"button":"_1oEtP","medium":"_1B4Ji","text":"_29h0-","icon":"zg0qG"};